export const findingsKeys = {
  all: ["findings"] as const,
  node: (nodeId: string) => [...findingsKeys.all, nodeId] as const,
};
